export default "__VITE_ASSET__hh3xnkv3__"